import { render, staticRenderFns } from "./SelectorProject.vue?vue&type=template&id=0443518a&"
import script from "./SelectorProject.vue?vue&type=script&lang=js&"
export * from "./SelectorProject.vue?vue&type=script&lang=js&"
import style0 from "./SelectorProject.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports